import React from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { PageHeader } from "CommonComponent";
import AccessRights from "utils/AccessRights";

const Header = () => {
  const session = useSelector((state) => state.session);
  const canAdd = AccessRights(session?.current_page_permissions, "add");

  return (
    <PageHeader title="Appraisal Setup">
      {canAdd ? (
        <Link to="/appraisalSetup/add">
          <button type="button" className="add-new-btn">
            <Image
              src="/assets/images/add-icon.svg"
              className="me-2"
              alt=""
              aria-hidden="true"
            />
            Add New
          </button>
        </Link>
      ) : null}
    </PageHeader>
  );
};

export default Header;
